import { DcBaseComponent } from '@deleteagency/dc';
import { eventBus } from '../../../general/js/events';

export const IMG_TRIGGER_LIGHTBOX = 'img_trigger_lightbox';

export default class PropertyCarouselTriggerComponent extends DcBaseComponent {
    static getNamespace() {
        return 'property-car-trigger';
    }

    onInit() {
        this.element.addEventListener('click', this.onClick);
    }

    onClick = () => {
        const index = this.element.dataset.dcPropertyCarTrigger;
        const target = this.element.dataset.target;
        eventBus.emit(IMG_TRIGGER_LIGHTBOX, target, index);
    }
}
